import { AppState } from '@/clients/redux/store'
import { TypedUseSelectorHook, useSelector } from 'react-redux'

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector

export type AppSelector = typeof useAppSelector
